import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corrporatecarrentalinpune() {



  const cardData =
  {
    keyword: 'Corporate Car Rental in Pune',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Car Rental in Pune',
    headingDescription: ' Pune Corporate Cars India Private Limited provides premium Corporate Car Rental in Pune, offering businesses a seamless, comfortable, and professionally managed travel experience. Our fleet includes luxury sedans, SUVs, and executive cars ideal for meetings, corporate events, airport transfers, and VIP travel. With trained chauffeurs, flexible rental plans, and punctual service, we ensure executives and employees travel with ease and efficiency. Whether your company requires short-term rentals, long-term dedicated vehicles, or on-demand chauffeur-driven cars, Pune Corporate Cars India Private Limited delivers reliable, safe, and high-quality corporate car rental solutions tailored to your organizational needs.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

    "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],



   "services": [
  {
    "name": "Corporate Car Hire Pune",
    "description": "Corporate Car Hire Pune offers premium, reliable, and professional car rental solutions tailored specifically for business use. Our service ensures seamless daily travel, executive movement, client visits, and airport transfers with a fleet of well-maintained sedans and SUVs. Each vehicle is driven by trained chauffeurs who prioritize punctuality, safety, and corporate etiquette. Companies enjoy flexible rental packages, predictable billing, and 24/7 support. Whether for meetings, official tours, or routine office travel, Corporate Car Hire Pune guarantees a smooth, comfortable, and efficient travel experience."
  },
  {
    "name": "Business Car Rental Pune",
    "description": "Business Car Rental Pune provides companies with high-quality vehicles for professional and daily business travel. Our fleet includes premium sedans, executive models, and spacious SUVs suited for meetings, conferences, and fieldwork. Every rental comes with a skilled chauffeur, ensuring comfort, safety, and time management. We offer flexible rental durations, from daily to monthly usage, with transparent pricing and well-maintained cars. Whether for client visits or executive commutes, Business Car Rental Pune enhances productivity through dependable and premium travel solutions."
  },
  {
    "name": "Employee Car Leasing Pune",
    "description": "Employee Car Leasing Pune provides long-term car leasing solutions for corporate staff, ensuring reliable and stress-free transportation. This service includes dedicated cars, full maintenance support, insurance handling, and trained chauffeurs. Companies can choose from various vehicle categories depending on employee roles and travel requirements. Leasing reduces operational costs, eliminates maintenance burdens, and ensures consistent mobility for field staff or executives. Employee Car Leasing Pune is ideal for organizations looking to simplify workforce transportation with predictable monthly expenses."
  },
  {
    "name": "Chauffeur Driven Car Rental Pune",
    "description": "Chauffeur Driven Car Rental Pune offers luxury, comfort, and professionalism for executives and business travellers. Each vehicle is accompanied by a courteous, trained chauffeur skilled in safe and punctual driving. Ideal for corporate meetings, airport transfers, VIP travel, and official visits. Cars come with clean interiors, AC, plush seating, and smooth suspension for a premium travel experience. Companies enjoy flexible hourly, daily, and monthly packages. Chauffeur Driven Car Rental Pune ensures elegance, convenience, and a high-standard travel experience for professionals."
  },
  {
    "name": "Pune Corporate Fleet Rental",
    "description": "Pune Corporate Fleet Rental provides companies with a full fleet of sedans, SUVs, and premium cars on a long-term basis. This service is ideal for large enterprises, IT companies, and corporate parks requiring continuous mobility for employees, executives, and clients. We manage vehicle maintenance, driver allocation, insurance, and replacements to ensure smooth operations. With streamlined billing, dedicated managers, and customizable plans, Pune Corporate Fleet Rental helps businesses improve travel efficiency and reduce transportation overheads."
  },
  {
    "name": "Corporate Sedan Rental Pune",
    "description": "Corporate Sedan Rental Pune offers smooth, stylish, and comfortable sedans perfect for official travel. Sedans like Dzire, Etios, Honda City, and Verna deliver excellent ride quality for executives and managers. This service includes professional chauffeurs, sanitized vehicles, and guaranteed punctuality. Ideal for meetings, inter-office travel, airport drops, and client movement. Companies benefit from flexible rental periods and predictable monthly pricing. Corporate Sedan Rental Pune ensures a premium and reliable travel experience for every business journey."
  },
  {
    "name": "Company Car Rental Pune",
    "description": "Company Car Rental Pune delivers fully managed car rental services for small, medium, and large businesses. Our fleet includes sedans, hatchbacks, SUVs, and premium models, all maintained to high standards. Vehicles come with trained chauffeurs, AC, clean interiors, and GPS for safe and smooth travel. Companies can opt for daily, weekly, or monthly rental plans. Perfect for employee movement, field visits, and corporate travel. Company Car Rental Pune ensures convenience, professionalism, and cost-effective mobility solutions."
  },
  {
    "name": "Pune Business Travel Car Hire",
    "description": "Pune Business Travel Car Hire offers dedicated travel solutions for professionals who frequently attend meetings, events, and field activities. Vehicles are equipped with comfortable interiors, strong AC, and smooth suspension for long drives. Our chauffeurs follow strict punctuality and safety standards. Whether you need hourly rental, full-day plans, or monthly packages, we provide flexible options. Pune Business Travel Car Hire ensures stress-free, efficient, and reliable travel for business operations across Pune and nearby cities."
  },
  {
    "name": "Office Staff Car Rental Pune",
    "description": "Office Staff Car Rental Pune offers dependable transportation solutions for corporate employees who require regular travel. Designed for daily office commutes, fieldwork, and inter-office movement, the service includes clean vehicles and verified chauffeurs. Companies can choose from hatchbacks, sedans, and SUVs based on their staff requirements. We offer fixed monthly billing, route management, and priority support. Office Staff Car Rental Pune ensures punctuality, safety, and comfort for employees across all office locations in Pune."
  },
  {
    "name": "Corporate SUV Rental Pune",
    "description": "Corporate SUV Rental Pune provides spacious and premium SUV vehicles such as Ertiga, Innova, and Crysta for executive and team travel. SUVs offer superior comfort, stronger suspension, and extra luggage space, making them ideal for long-distance business trips, corporate tours, and airport transfers. Each SUV is maintained regularly and driven by professional chauffeurs. With flexible rental durations and predictable pricing, Corporate SUV Rental Pune ensures luxury, safety, and convenience for corporate travelers."
  },
  {
    "name": "Premium Corporate Car Hire Pune",
    "description": "Premium Corporate Car Hire Pune offers luxury vehicles including Camry, Mercedes, BMW, and premium sedans for VIP corporate travel. Designed for high-profile executives, client hospitality, and important business events, these cars deliver unmatched elegance and comfort. Chauffeurs are professionally trained, well-dressed, and skilled in corporate etiquette. Vehicles come with plush seating, silent cabins, and advanced features. Premium Corporate Car Hire Pune ensures a world-class travel experience for your organization’s top-level mobility needs."
  },
  {
    "name": "Best Car Rental for Corporate Pune",
    "description": "Best Car Rental for Corporate Pune offers top-quality vehicles, professional chauffeurs, and exceptional service standards for businesses of all sizes. With a wide fleet of sedans, SUVs, and premium models, companies receive flexible and cost-effective mobility options. The service includes punctual pickups, route optimization, sanitized cars, and 24/7 support. Perfect for executives, staff, and visiting clients. Best Car Rental for Corporate Pune ensures a reliable, safe, and prestigious travel experience for all corporate journeys."
  },
  {
    "name": "Monthly Car Rental for Corporate Pune",
    "description": "Monthly Car Rental for Corporate Pune provides long-term mobility solutions with dedicated vehicles and drivers assigned to your organization. This service helps businesses control transportation costs while ensuring consistent availability. Cars are well-maintained, insured, sanitized, and replaced immediately if required. Ideal for executives, field teams, and employees who travel regularly. Monthly Car Rental for Corporate Pune guarantees smooth, reliable, and economical monthly transportation."
  },
  {
    "name": "Long Term Corporate Car Rental Pune",
    "description": "Long Term Corporate Car Rental Pune offers businesses the flexibility of renting cars for several months or years with complete management support. We handle vehicle servicing, driver allotment, paperwork, and insurance, ensuring zero operational burden. Companies benefit from predictable long-term costs, premium vehicles, and priority service. Ideal for large teams, corporate expansions, extended projects, and permanent travel requirements. Long Term Corporate Car Rental Pune ensures hassle-free and dependable long-duration mobility."
  },
  {
    "name": "Executive Car Hire Pune",
    "description": "Executive Car Hire Pune provides premium sedans and high-comfort vehicles designed for corporate executives and senior professionals. This service ensures smooth, luxurious, and safe travel for meetings, conferences, and airport transfers. Vehicles feature plush interiors, AC, silent cabins, and top-notch maintenance. Chauffeurs are trained in corporate etiquette, defensive driving, and punctuality. Executive Car Hire Pune ensures an impressive and comfortable travel experience for high-level business requirements."
  }
],
"tableData": [
  ["Corporate Car Hire Pune", "Business Car Rental Pune"],
  ["Employee Car Leasing Pune", "Chauffeur Driven Car Rental Pune"],
  ["Pune Corporate Fleet Rental", "Corporate Sedan Rental Pune"],
  ["Company Car Rental Pune", "Pune Business Travel Car Hire"],
  ["Office Staff Car Rental Pune", "Corporate SUV Rental Pune"],
  ["Premium Corporate Car Hire Pune", "Best Car Rental for Corporate Pune"],
  ["Monthly Car Rental for Corporate Pune", "Long Term Corporate Car Rental Pune"],
  ["Executive Car Hire Pune", ""]
],


  "whychoose": [
  {
    "WhyChooseheading": "Corporate Car Rental in Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers premium corporate car rental services in Pune, providing reliable transportation solutions for business travel and corporate events."
  },
  {
    "WhyChooseheading": "Premium Fleet for Corporate Travel",
    "WhyChoosedescription": "Choose from a wide range of executive cars designed to offer comfort, style, and professionalism for corporate needs."
  },
  {
    "WhyChooseheading": "Well-Maintained and Hygienic Vehicles",
    "WhyChoosedescription": "All our cars are regularly serviced and sanitized, ensuring a clean, safe, and comfortable travel experience."
  },
  {
    "WhyChooseheading": "Transparent Corporate Pricing",
    "WhyChoosedescription": "Enjoy competitive and clear pricing with no hidden charges, ideal for both short-term and long-term corporate rentals."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from hourly, daily, weekly, or monthly rental plans tailored specifically for corporate requirements."
  },
  {
    "WhyChooseheading": "Experienced Chauffeurs",
    "WhyChoosedescription": "Our professional drivers are trained for corporate travel, ensuring punctuality, safety, and a smooth riding experience."
  },
  {
    "WhyChooseheading": "24/7 Corporate Support",
    "WhyChoosedescription": "We provide round-the-clock customer support to assist with bookings, travel coordination, and last-minute schedule adjustments."
  },
  {
    "WhyChooseheading": "Fast and Hassle-Free Booking",
    "WhyChoosedescription": "Book your corporate rental quickly via our online platform or phone, with instant confirmation and reliable service."
  }
]
























  }

 const faqData = [
  {
    question: 'Does Pune Corporate Cars India Private Limited offer corporate car rental services in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited provides premium and reliable corporate car rental services for business travel, meetings, events, and employee transportation.',
  },
  {
    question: 'How can I book a corporate car rental with Pune Corporate Cars India Private Limited?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cars are available for corporate car rentals in Pune?',
    answer: 'We offer a wide fleet including sedans, SUVs, luxury cars, and premium vehicles suitable for all corporate travel needs.',
  },
  {
    question: 'Are drivers provided for corporate car rentals in Pune?',
    answer: 'Yes, we provide trained, professional, and well-groomed drivers for all corporate rental bookings.',
  },
  {
    question: 'Can Pune Corporate Cars India Private Limited provide rental cars for daily, weekly, or monthly use?',
    answer: 'Absolutely. We offer flexible rental plans including daily, weekly, and monthly corporate car rental packages.',
  },
  {
    question: 'Is the corporate car rental service available 24×7 in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited provides round-the-clock availability for all corporate rental requirements.',
  },
  {
    question: 'What safety and hygiene measures are followed for corporate car rentals?',
    answer: 'All cars are sanitized regularly and drivers adhere to strict safety and hygiene standards.',
  },
  {
    question: 'What payment options are available for corporate car rentals in Pune?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate billing options.',
  },
  {
    question: 'Will customer support be available during the corporate rental period?',
    answer: 'Yes, our 24×7 support team is available throughout your corporate car rental duration.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Joshi',
    feedback: 'Pune Corporate Cars India Private Limited provided excellent corporate car rental service. The vehicle was premium and the driver was extremely professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Neha Bapat',
    feedback: 'Highly reliable and punctual service. Perfect choice for corporate travel in Pune. Strongly recommend Pune Corporate Cars India Private Limited.',
    rating: 5,
  },
];








































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Car Rental in Pune",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-car-rental-pune.jpg", // replace with actual image URL
  "description": "Premium corporate car rental services in Pune, offering chauffeur-driven sedans, SUVs, and executive cars for employee transportation, business travel, and long-term corporate needs. Pune Corporate Cars India Private Limited ensures reliable and comfortable rides for your company.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",  // update if needed
    "ratingCount": "5300", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2000", // starting price per day, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-car-rental-pune"
  }
};








  return (
    <div>
<Helmet>
  <title>Corporate Car Rental in Pune | Executive & Chauffeur Cars | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Premium corporate car rental in Pune with chauffeur-driven sedans, SUVs, and executive cars for employee transport, business travel, and long-term corporate needs. Book reliable rides with Pune Corporate Cars India Private Limited."
  />

  <meta
    name="keywords"
    content="Corporate Car Hire Pune, Business Car Rental Pune, Employee Car Leasing Pune, Chauffeur Driven Car Rental Pune, Pune Corporate Fleet Rental, Corporate Sedan Rental Pune, Company Car Rental Pune, Pune Business Travel Car Hire, Office Staff Car Rental Pune, Corporate SUV Rental Pune, Premium Corporate Car Hire Pune, Best Car Rental for Corporate Pune, Monthly Car Rental for Corporate Pune, Long Term Corporate Car Rental Pune, Executive Car Hire Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/3.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corrporatecarrentalinpune;